export const vaccination = {
  // Вкладка «Журнал ведения особей»
  individual: {
    viewList: '[perm]-[vaccination]-view-individual-list',
    viewListFiltering: '[perm]-[vaccination]-view-individual-list-filtering',
    addPassport: '[perm]-[vaccination]-add-individual-passport',
    viewPassport: '[perm]-[vaccination]-view-individual-passport',
    editPassport: '[perm]-[vaccination]-edit-individual-passport',
    viewListArchive: '[perm]-[vaccination]-view-individual-list-archive',
    viewPassportArchive: '[perm]-[vaccination]-view-individual-passport-archive',
    deletePassport: '[perm]-[vaccination]-delete-individual-passport',
    importHistory: '[perm]-[vaccination]-import-individual-history',
  },

  // Вкладка «Протокол мероприятий»
  eventProtocol: {
    view: '[perm]-[vaccination]-view-event-protocol',
    add: '[perm]-[vaccination]-add-event-protocol',
    edit: '[perm]-[vaccination]-edit-event-protocol',
    delete: '[perm]-[vaccination]-delete-event-protocol',
  },

  // Вкладка «Контроль»
  control: {
    viewMonitoring: '[perm]-[vaccination]-view-vaccination-monitoring',
  },

  // Вкладка «Наряд»
  task: {
    view: '[perm]-[vaccination]-view-task',
    create: '[perm]-[vaccination]-create-task',
    export: '[perm]-[vaccination]-export-task',
    viewArchive: '[perm]-[vaccination]-view-archive-tasks',
    filterArchiveTable: '[perm]-[vaccination]-filter-archive-tasks-table',
    exportArchive: '[perm]-[vaccination]-export-archive-task',
    eventAndIndividualCompletion:
      '[perm]-[vaccination]-task-event-and-individual-completion',
  },
} as const;
